/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzResetUserPermissionManagedPermissionsMutationResponse, UsersAuthzResetUserPermissionManagedPermissionsPathParams, UsersAuthzResetUserPermissionManagedPermissions401, UsersAuthzResetUserPermissionManagedPermissions403 } from "../models/UsersAuthzResetUserPermissionManagedPermissions";

export function getUsersAuthzResetUserPermissionManagedPermissionsUrl(userId: UsersAuthzResetUserPermissionManagedPermissionsPathParams["userId"], permission: UsersAuthzResetUserPermissionManagedPermissionsPathParams["permission"]) {
  const res = { method: 'POST', url: `/users-authz/v1/users/${userId}/permissions/${permission}/reset` as const }
  return res
}

/**
 * @description Requires CLIENT_ADMIN role or client API key
 * @summary Reset a permission for a user
 * {@link /users-authz/v1/users/:userId/permissions/:permission/reset}
 */
export async function usersAuthzResetUserPermissionManagedPermissions(userId: UsersAuthzResetUserPermissionManagedPermissionsPathParams["userId"], permission: UsersAuthzResetUserPermissionManagedPermissionsPathParams["permission"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<UsersAuthzResetUserPermissionManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzResetUserPermissionManagedPermissions401 | UsersAuthzResetUserPermissionManagedPermissions403>, unknown>({ method : "POST", url : getUsersAuthzResetUserPermissionManagedPermissionsUrl(userId, permission).url.toString(), ... requestConfig })
  return res.data
}